export interface PhysicalLocationListItem {
  id: number;
  name: string;
  distribution: {
    quantity: number | null;
  };
}

export interface PhysicalLocationOverflowItem {
  id: number;
  text: string;
}

export interface PhysicalLocationOverflowDisplay {
  countLabel: string;
  hasTooltip: boolean;
  items: PhysicalLocationOverflowItem[];
}

export function buildPhysicalLocationOverflowDisplay(
  locations: readonly PhysicalLocationListItem[] | null | undefined
): PhysicalLocationOverflowDisplay {
  const filtered = (locations ?? []).filter((location) => location.name?.trim());

  if (filtered.length === 0) {
    return { countLabel: '-', hasTooltip: false, items: [] };
  }

  const items = filtered.map((location) => {
    const quantity = location.distribution.quantity;
    const name = location.name?.trim();

    if (quantity === null) {
      return { id: location.id, text: name };
    }

    const suffix = quantity !== 1 ? 's' : '';
    return { id: location.id, text: `${name} — ${quantity} cópia${suffix}` };
  });

  return {
    countLabel: filtered.length === 1 ? '1 local' : `${filtered.length} locais`,
    hasTooltip: true,
    items,
  };
}
